// extracted by mini-css-extract-plugin
module.exports = {"pdfViewer":"_2OtXBpzcFbtegvfUyrP3FC","pdfToolbar":"_3WXZyXLxCD4kLpHCU_Dhg8","pdfPagination":"_1i-UQrUAWNh1Wr8iG5nFT-"};